"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SablierFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SablierFactory = /** @class */ (function (_super) {
    __extends(SablierFactory, _super);
    function SablierFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SablierFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SablierFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SablierFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SablierFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SablierFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SablierFactory;
}(contracts_1.ContractFactory));
exports.SablierFactory = SablierFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "senderBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "recipientBalance",
                type: "uint256",
            },
        ],
        name: "CancelStream",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stopTime",
                type: "uint256",
            },
        ],
        name: "CreateStream",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "WithdrawFromStream",
        type: "event",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
        ],
        name: "cancelStream",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "stopTime",
                type: "uint256",
            },
        ],
        name: "createStream",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
        ],
        name: "deltaOf",
        outputs: [
            {
                internalType: "uint256",
                name: "delta",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
        ],
        name: "getStream",
        outputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "stopTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "remainingBalance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ratePerSecond",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "nextStreamId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "streamId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawFromStream",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
